import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  movieId: string;
}

export default function FavoriteButton({ movieId }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  return (
    <button
      type="button"
      onClick={() => toggleFavorite(movieId)}
      className={`inline-flex items-center gap-2 h-12 px-5 rounded-md border text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
        active
          ? "bg-primary-500/15 border-primary-500/60 text-primary-300"
          : "bg-background-200/70 border-background-300/70 text-foreground-800 hover:border-primary-500/60 hover:text-primary-400"
      }`}
    >
      <i className={active ? "ri-heart-fill text-lg" : "ri-heart-line text-lg"}></i>
      {active ? "已收藏" : "收藏"}
    </button>
  );
}